import { render, staticRenderFns } from "./GeneralPresets.vue?vue&type=template&id=3a33f161"
import script from "./GeneralPresets.vue?vue&type=script&lang=js"
export * from "./GeneralPresets.vue?vue&type=script&lang=js"
import style0 from "./GeneralPresets.vue?vue&type=style&index=0&id=3a33f161&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports